/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc 質問メッセージ
 *
 * @author genka
 * @copyright Copyright 2019 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-card class="fc-question-message" :class="[messageClass]">
  <div class="message-text" v-html="messageHtmlText"></div>
  <div class="answer-button-area-wrapper">
    <div class="answer-button-area">
      <el-button class="answer-button" size="small" v-for="answerInfo in answerList" :key="answerInfo.id" :disabled="!permissionSendAnswerMessage(answerInfo)" :type="answerInfo.buttonType || ''" @click="sendAnswerMessage(answerInfo)">{{answerInfo.label}}</el-button>
    </div>
  </div>
</el-card>
</template>
<script>
import StringUtil from '@/utils/StringUtil'
import FcMessageUtil from '@/utils/FcMessageUtil'

import {
  Card,
  Button
} from 'element-ui'

export default {
  name: 'FcQuestionMessage',
  components: {
    'el-card': Card,
    'el-button': Button
  },
  props: [
    /**
     * メッセージ情報
     */
    'messageInfo',
    /**
     * 無効状態
     */
    'disabled',
    /**
     * リクエスト中か
     */
    'requesting',
    /**
     * 最後のメッセージか
     */
    'lastSnsMessage'
  ],
  data() {
    return {}
  },
  computed: {
    /**
     * メッセージ内容部分に適用するClass（自分のメッセージor他人のメッセージ）を取得します。
     * @return {String} メッセージ内容部分に適用するClass（自分のメッセージor他人のメッセージ）
     */
    messageClass() {
      return 'fc-text-message ' + FcMessageUtil.messageDistributionClass(this.messageInfo)
    },
    /**
     * メッセージ内容のHTMLテキストを取得します。
     * @return {String} メッセージ内容のHTMLテキスト
     */
    messageHtmlText() {
      return StringUtil.getHtmlTextMarkUpHttpURL(this.messageInfo.message)
    },
    /**
     * 回答一覧
     * @return {Array} 回答一覧
     */
    answerList() {
      return []
    }
  },
  methods: {
    /**
     * 回答を送信可能か
     * @return {Boolean}
     */
    permissionSendAnswerMessage(answerInfo) {
      answerInfo = answerInfo || {}
      return (this.lastSnsMessage && !this.disabled && !this.requesting) || answerInfo.alwaysEnable
    },
    /**
     * 回答を送信する
     * @param  {Object} answerInfo 回答情報
     */
    sendAnswerMessage(answerInfo) {
      if (!this.permissionSendAnswerMessage(answerInfo)) {
        return
      }
      if (answerInfo.waitChatReceive) {
        this.$emit('waitChatReceive')
      }
      this.$emit('sendAnswerMessage', this.getSendAnswerMessageByAnswerInfo(answerInfo))
    },
    /**
     * 回答を送信する
     * @param  {String} label ラベル
     * @return {Boolean} 送信したか
     */
    sendAnswerMessageByLabel(label) {
      let answerInfoOfLabel = null
      let answerList = this.getSendMessageAnswerList()
      answerList.some((answerInfo) => {
        if (answerInfo.label === label) {
          answerInfoOfLabel = answerInfo
          return true
        }
        if (answerInfo.labelSynonym != null) {
          answerInfo.labelSynonym.some((synonym) => {
            if (synonym === label) {
              answerInfoOfLabel = Object.assign({}, answerInfo)
              answerInfoOfLabel.label = label
              return true
            }
          })
        }
      })
      if (answerInfoOfLabel == null) {
        return false
      } else {
        this.sendAnswerMessage(answerInfoOfLabel)
        return true
      }
    },
    /**
     * 回答用送信メッセージを行う回答一覧を取得します。
     */
    getSendMessageAnswerList() {
      return this.answerList
    },
    /**
     * 回答用送信メッセージ情報を取得する
     * @param  {Object} answerInfo 回答情報
     */
    getSendAnswerMessageByAnswerInfo(answerInfo) {
      return answerInfo
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chatWindow/chatMain/message/FcQuestionMessage.vue